<template>
  <div>
    <van-nav-bar
      title="选择载具"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
    />
    <van-search
      v-model="searchvalue"
      placeholder="请输入载具号搜索"
      @search="onSearch"
    />
    <van-radio-group
      v-model="checked"
      style="height: 100vh; background-color: rgba(228, 228, 228, 1);"
    >
      <van-cell-group class="chooseoverflow">
        <div v-for="(item,index) in list" :key="item.vehicleId">
          <van-cell clickable @click="changeCheck(item.vehicleId)">
            <van-row>
              <van-col>{{ item.vehicleCode }}</van-col>
            </van-row>
            <template #right-icon>
              <van-radio :name="item.vehicleId" />
            </template>
          </van-cell>
          <div class="divider" v-if="index!=(list.length-1)"></div>
        </div>
      </van-cell-group>
    </van-radio-group>
  </div>
</template>

<script>
import { reactive, ref } from "vue";
import http from "../../api/dashboard";
import {
  NavBar,
  Button,
  Icon,
  Col,
  Row,
  Cell,
  CellGroup,
  Tag,
  Field,
  DatetimePicker,
  Overlay,
  Checkbox,
  CheckboxGroup,
  RadioGroup,
  Radio,
  Search,
} from "vant";
export default {
  props: ["vehiclechecked"],
  components: {
    [Button.name]: Button,
    [Icon.name]: Icon,
    [Col.name]: Col,
    [Row.name]: Row,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Tag.name]: Tag,
    [Field.name]: Field,
    [DatetimePicker.name]: DatetimePicker,
    [Overlay.name]: Overlay,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [NavBar.name]: NavBar,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Search.name]: Search,
  },
  setup() {
    const list = ref([]);
    return {
      list,
      checked: "",
      searchvalue: "",
    };
  },
  methods: {
    changeCheck(val) {
      this.checked = val;
      var vehicleInfo =
        this.list[this.list.findIndex((item) => item.vehicleId == val)];
      var vehicleCode = vehicleInfo.vehicleCode;
      var driverInfo = vehicleInfo.defaultDriverList
        ? vehicleInfo.defaultDriverList.length > 0
          ? vehicleInfo.defaultDriverList[0]
          : null
        : null;
      this.$emit("closeVehicle", val, vehicleCode, driverInfo);
    },
    getVehicleList() {
      var that = this;
      http
        .getVehicleList({
          pageNum: "1",
          pageSize: "20",
          vehicleCode: this.searchvalue,
        })
        .then((res) => {
          that.list = reactive(res.data.list ? res.data.list : []);
        });
    },
    onSearch() {
      this.getVehicleList();
    },
    onClickLeft() {
      this.$emit("closeVehicle");
    },
  },
  mounted() {
    this.checked = reactive(this.vehiclechecked);
    this.$forceUpdate();
    this.getVehicleList();
  },
};
</script>

<style lang="less" scoped="scoped">
.divider {
  border-bottom: 1px solid #CCCCCC;
  padding: 0 20px;
}
.chooseoverflow{
    overflow: auto;
    height: calc(100vh - 110px);
}
</style>